module.exports = __webpack_public_path__ + "img/pb_gallery_4.a0d5c8dd.gif";